/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(BaseClass) {

	var ActionHandler = BaseClass.extend({

		createPDF: function(context, pageSize, printFilters){
			const printFeature = context.getCurrentContentView().getDashboardApi().getFeature('Print');
			const pageOptions = {
				pageSize: pageSize,
				printFilters: printFilters
			};
			const id = context.getCurrentContentView().getDashboardApi().getCanvas().getContent().getId();
			printFeature.print(id, context, pageOptions);
		}
	});
	return ActionHandler;
});
